import { Component, OnInit } from '@angular/core';
import {BanksService} from "../../../services/banks.service";
import {LoadingService} from "../../../services/loading.service";


@Component({
  selector: 'app-banks',
  templateUrl: './banks.component.html',
  styleUrls: ['./banks.component.scss']
})
export class BanksComponent implements OnInit {
  banks: any[] = [];
  filteredBanks: any[] = [];

  searchTerm: string = '';

  constructor(
    private bankService: BanksService,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.loadBanks();
  }

  private loadBanks(): void {
    this.loadingService.show();
    this.bankService.getAll().subscribe({
      next: (response) => {
        // Manejar estructura paginada: data puede ser array directo o {data: [...], totalCount: ...}
        const data = response?.data;
        this.banks = Array.isArray(data) ? data : (data?.data || []);
        this.filteredBanks = [...this.banks];
        this.loadingService.hide();
      },
      error: (err) => {
        console.error(err);
        this.loadingService.hide();
      }
    });
  }

  applyFilters(): void {
    const search = this.searchTerm.toLowerCase();
    this.filteredBanks = this.banks.filter(bank =>
      bank.name.toLowerCase().includes(search) ||
      bank.accountNumber.toLowerCase().includes(search) ||
      bank.currency.toLowerCase().includes(search)
    );
  }
}
